// @ts-nocheck
import { Component, DoCheck, QueryList, Input, OnInit, ViewEncapsulation, ViewChild, ElementRef, Output, EventEmitter, ChangeDetectorRef, HostListener } from '@angular/core';
// import { DynamicFormBuildConfig, RxDynamicFormBuilder } from '@rxweb/reactive-dynamic-forms';
import { ReactiveFormConfig } from '@rxweb/reactive-form-validators';
import { tempDynamicStoreconfig } from '../tempDynamicStoreconfig';
import { Router, ActivatedRoute } from '@angular/router';
import { IonSlides, NavController, Platform, IonSelect } from '@ionic/angular';
import { AppService } from 'src/app/services/app.service';
import { AsyncUtilityService } from 'src/app/services/async-utility.service';
import { IdbService } from '../../services/idb.service';
import * as EventEmitter from 'node:events';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { ModalConfirmaddressComponent } from '../../user-panel/tasks/modal-confirmaddress/modal-confirmaddress.component'
import { helpGuideJson } from '../../../assets/helpGuide';
import { GpsService } from 'src/app/services/gps.service';
import { AppEnum } from 'src/app/appenum';
import { AppSettings } from 'src/app/app.settings';
import { TranslateService } from '@ngx-translate/core';
import { EncryptionService } from 'src/app/services/encryption.service';
import { environment } from 'src/environments/environment';
import { PermissionService } from 'src/app/services/permission.service';
import { take } from 'rxjs/operators';
import { register } from 'swiper/element/bundle';
import { Subscription } from 'rxjs';
import { AppNavigation } from 'src/app/services/app-navigation';
import { LoggingService } from 'src/app/services/logging.service';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';
// import { SwiperModule } from 'swiper/angular';
interface SegmentItem {
  value: string;
  labelKey: string;
}
register();
declare function dynamicFormsEvent(param: any, varb, SERVER_DATA = []): any;
declare function backButtonEvent(controlName: any): any;
declare function setMasterCategory(controlName: any): any;
declare function getParentCategory(): any;

@Component({
  selector: 'app-dynamic-card',
  templateUrl: './dynamic-card.component.html',
  styleUrls: ['./dynamic-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class DynamicCardComponent implements OnInit, DoCheck {
  zoneValidationMap: Map<string, boolean> = new Map();
  public componentName = "Dynamic-Card Component";
  public backButtonSubscription;
  public customJsonForm: any;
  public lastSelectedTierDetails;
  public updatedFieldsforCustomForm;
  public perResult: any;
  public isHelpJson = false;
  dynamicclass: any;
  public lastSelectedZoneIndex;
  public indexOfSelectedCat;
  public parentData: any = null;

  public selectedZoneIndex: any = 0;
  public taskDetails;
  public zoneObj: any;
  public isZone = true;
  public customTaskChecklist: any;
  public customFormJson: any;
  public count: any;
  public label: any;
  public selectedControlToMaintan: any;
  public featurename: any = '';
  disableaddZone: boolean = false;
  public selectedTreeControlList: any;
  public slideOpts = {
    slidesPerView: 3, // Number of visible tabs at a time
    slidesPerGroup: 3,
    spaceBetween: 8,
    watchOverflow: true,
    pagination: false,
    navigation: true,
    loop: false
  };

  @ViewChild('tabsSlider', { static: false }) tabsSlider: IonSlides;

  @ViewChild('ZoneCardsSlider') swiperRef: ElementRef | undefined;

  @Input() PageName = 'dynamicCard';
  @Input() taskId: any;
  @Input() lat = null;
  @Input() long = null;

  @Input() uiBindings = []
  @Input() serverData = [];
  @Input() serverUiBindingsData = [];
  @Input() serverDataKeys = [];
  @Input() photoData = [];
  @Input() serverDataQues: any;
  @Output() backbtnControl = new EventEmitter(false);
  @Input() taskCheckList: any;
  @Input() isNavigateToChild: any;

  public finalvalidationList = {};
  public imagesList = [];
  public listForAddNewZone = [];
  public buttonText: any;

  commentDialogControlName = '';
  comments = '';
  controlLabel = '';
  isshowtip = false;
  public isDataLoaded = false;
  hidePhotobutton: any;
  multilang: any = [];
  @ViewChild('myModal', { static: false }) myModal: ElementRef;
  @ViewChild('myModal1', { static: false }) myModal1: ElementRef;
  @ViewChild('myModal2', { static: false }) myModal2: ElementRef;
  @ViewChild('feedBackFormPopup', { static: false }) feedBackFormPopup: ElementRef;
  @ViewChild('taskchecklistModal', { static: false }) taskchecklistModal: ElementRef

  elm: HTMLElement;
  elm1: HTMLElement;
  elm2: HTMLElement;
  @ViewChild('additionalFeature') additionalFeatureRef: IonSelect;
  @ViewChild('addZoneSelection') addZoneSelection: IonSelect;
  backdropVisible = false;
  modalData: {}
  ishelpJson: any;
  helpGuideJson: any;
  ShowSpinner = false;
  public mappedData: any;
  public zoneNames: any = [];
  public orgMasterData: any = [];
  private static _zoneNamesCache: any[] | null = null;
  private static _orgMasterDataCache: any[] | null = null;

  selectedTabIndex = 0;
  // selectedTab = 'Media';
  showZoneName: any;
  goBackLabel: string = '';        // text shown in back button, e.g. "Auto Claim"
  showAllImages: boolean = false;
  address: any;
  AddLastOrNext: string = 'addLast';
  additionalSelectedControl: any;
  public repeatableControlList;
  public featureNamePlaceholder: any;



  slideOpts = {
    slidesPerView: 'auto',
    centeredSlides: false,
    spaceBetween: 8,
    initialSlide: 0,
    pagination: false,
    allowTouchMove: true,   // ensure swiping is enabled
    speed: 300
    // Space between tabs
  };
  showNextButton = true;
  showPrevButton = false;
  metaConfigData: any;
  isAddZoneEnable: boolean = false;
  agentId: any;
  @Input() permissionMessage!: PermissionMessageComponent;
  permissionDenied$ = this.permissionService.permissionDenied$;
  segments: SegmentItem[] = [];
  selectedTab: string | null = null;
  submitlaterText: any;
  cancelText: any;
  yesText: any;
  zoneKeys = [];
  templatesData: any = [];
  flatTemplateJson: any = [];
  isAddressVerificationEnabled: boolean = false;
  saveLaterTitle: any;
  saveNewBtn: any;
  orgTemplateApi: Subscription;
  private cacheInitialized = false;
  showSuccessIcon = false;
  private wasMediaPending = false;
  private successIconTimer: any;
  showSuccessIconQues = false;
  private wasQuesPending = false;
  private successIconQuesTimer: any;
  private prevQuesState = false;
  showZoneSuccessIcon = false;
  private wasZonePending = false;
  private zoneSuccessIconTimer: any;
  mediaHasError = false;
  quesHasError = false;
  isLocationAllowed: any;
  constructor(public route: ActivatedRoute, public _appenum: AppEnum, public _appServices: AppService,
    public _router: Router, private _nav: AppNavigation, private _activatedroute: ActivatedRoute,
    public _asyncUtilityService: AsyncUtilityService, public idbservice: IdbService,
    public _tempDynamicFormConfig: tempDynamicStoreconfig, public platform: Platform,
    public sanitizer: DomSanitizer, public modalController: ModalController,
    public _translateService: TranslateService,
    public permissionService: PermissionService,
    private changeDetectorRef: ChangeDetectorRef, public _gpsService: GpsService, public _appSetting: AppSettings,
    public encryptionService: EncryptionService,
    private loggingService: LoggingService) {
    wrapAllMethodsWithLogging(this, this.componentName);
    this.featureNamePlaceholder = 'placeholder_text.feature_name_text';
    this.submitlaterText = this._translateService.instant('self_pwa_text.submit_later_text');
    this.saveLaterTitle = this._translateService.instant('common_text.save_for_later_text');
    this.saveNewBtn = this._translateService.instant('common_text.save_new_btn');
    this.cancelText = this._translateService.instant('common_btn_text.cancel_btn');
    this.yesText = this._translateService.instant('common_btn_text.yes_btn');
    this.isAddressVerificationEnabled = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.isAddressVerificationEnable))
    this.isLocationAllowed = this.encryptionService.decrypt(
      this.encryptionService.localstorageDecrypt(
        this._appenum.EntityOfLocalStorageKeys.isLocationAllowed
      ));
    // this.loadDynamicModel();
  }

  async ngOnInit() {
    // this.zoneNames.length = 0;
    // this.orgMasterData.length = 0;
    await this.loadZoneMasterCache();
    if (!DynamicCardComponent._orgMasterDataCache) {
      DynamicCardComponent._orgMasterDataCache = await this.idbservice.getOrgMasterData(
        this.taskId,
        this.orgId
      );
    }
    this.orgMasterData = DynamicCardComponent._orgMasterDataCache;
    await this.loadDynamicModel();
    this.metaConfigData = JSON.parse(this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.channelConfignData)));
    this.isAddZoneEnable = this.metaConfigData?.is_add_zone_enable;
    this.multilang = JSON.parse(this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.languageData)));
    const latLng = new google.maps.LatLng(this.lat, this.long);
    const request = { latLng: latLng };
    const geocoder = new google.maps.Geocoder();
    const lastAddress = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.lastAddress));
    if (this.isAddressVerificationEnabled) {
      geocoder.geocode(request, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            this.address = results[0]?.formatted_address
            this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.lastAddress, this.address)
          }
        } else {
          console.error("Geocode failed for the following reason: " + status);
        }
      });
    }
    if (lastAddress) {
      this.address = lastAddress
    } else {
      geocoder.geocode(request, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            this.address = results[0]?.formatted_address
            this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.lastAddress, this.address);
          }
        } else {
          console.error("Geocode failed for the following reason: " + status);
        }
      });
    }
    // if (this.photoData && this.photoData.length > 0) {
    //   this.takenPhotoMessage = this._translateService.instant('common_text.taken_media_message');
    //   setTimeout(() => {
    //     this._appServices.presentToast(this.takenPhotoMessage)
    //   }, 500)
    // }
    this._tempDynamicFormConfig.serverData = this.serverData;
    let allZone = this._tempDynamicFormConfig.GetAllZones();
    allZone.forEach((item, i) => {
      this._tempDynamicFormConfig.jsonValueMapped(this.serverData[i].templateId)
    })
    this._tempDynamicFormConfig.taskTemplatesDetails = this.serverData;
    setTimeout(() => {
      this.reBindData(this._tempDynamicFormConfig.lastSlideIndex);
    }, 500);
  }

  getZoneName(templateId) {
    return this.zoneNames.filter(item => item.templateId == templateId)[0].ZoneName[this._appSetting.selectedLanguage]
  }
  async loadDynamicModel() {
    const gettaskDetail = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.taskDetail));
    this.taskDetails = JSON.parse(gettaskDetail)
    this.getZoneFromLocal();
    this.registerEventListener();
    var ths = this;
    this.lastSelectedZoneIndex = this._activatedroute.snapshot.paramMap.get('selectedZone');
    this.indexOfSelectedCat = this._activatedroute.snapshot.paramMap.get('selectedCategory');
  }

  registerEventListener() {
    document.body.addEventListener('click', this.eventListener, {
      passive: true
    })
  }

  private eventListener = async (e) => {
    // var selectedZoneIndex = this._tempDynamicFormConfig.lastSlideIndex = await this.ZoneCardsSlider.getActiveIndex();
    var selectedZoneIndex = this._tempDynamicFormConfig.lastSlideIndex = this.selectedTabIndex;
  };

  updateTempDynamicConfig() {
    this._tempDynamicFormConfig.taskTemplatesDetails = this.serverData;
  }

  getZoneFromLocal() {
    try {
      const res = this.orgMasterData.filter(
        item =>
          item.businessType === this.taskDetails.businesstype &&
          item.documentType === this.taskDetails.documenttype &&
          (item.taskType === this.taskDetails.taskname || "all")
      );
      const allZone = this._tempDynamicFormConfig.GetAllZones();
      const tempIds = allZone.map(zone => zone.templateId);
      this.listForAddNewZone = res.filter(template => !tempIds.includes(template.templateId));
      this.disableaddZone = false;
    } catch (error) {
      this.loggingService.logFunctionError(
        error,
        'getZoneFromLocal',
        this.componentName,
        {
          taskId: this.taskId,
        }
      );
      this.disableaddZone = false;
    }
  }

  async addNewZone(zoneDetails) {
    try {
      this.disableaddZone = true;
      const newZoneAdded = [];
      this.agentId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId));
      this.parentData = null;
      zoneDetails = zoneDetails.target.value;
      if (zoneDetails == "") {
        return;
      }
      this.isDataLoaded = false;
      zoneDetails.taskId = this.taskDetails.TaskId;
      zoneDetails.templateName = zoneDetails.zoneTemplateName;
      zoneDetails.templateQues = zoneDetails.templateQues;
      zoneDetails.templateId = zoneDetails.templateId;
      zoneDetails.templateJsonValue = null;
      zoneDetails.templateQuesValue = null;

      const zoneObj: any = {
        createdAt: zoneDetails.createdAt,
        noCatImageReason: '',
        status: zoneDetails.status,
        taskId: this.taskDetails.TaskId,
        templateId: zoneDetails.templateId,
        templateJson: zoneDetails.templateJson,
        templateJsonValue: zoneDetails.templateJsonValue,
        templateName: zoneDetails.templateName,
        templateQues: zoneDetails.templateQues,
        templateQuesValue: zoneDetails.templateJsonValue,
        version: zoneDetails.version,
        zoneKeys: { keys: [zoneDetails.templateId] }
      }
      newZoneAdded.push(zoneObj);
      await this._appServices.prepareTaskTemplateData(
        newZoneAdded,
        this.agentId,
        false
      );
      await this._tempDynamicFormConfig.serverData.push(zoneDetails);
      this.selectedZoneIndex = this._tempDynamicFormConfig.lastSlideIndex;
      this.updateTemplateOnserver(zoneDetails);
      setTimeout(async () => {
        this.isNavigateToChild = false;
        await this.reBindData(this.selectedZoneIndex);
      }, 1000);
    }
    catch (error) {
      await this.loggingService.logFunctionError(
        error,
        'addNewZone',
        this.componentName,
        {
          taskId: this.taskDetails?.TaskId,
          agentId: this.agentId,
          zoneDetails
        }
      );
    }
  }

  async updateTemplateOnserver(zoneDetails) {
    const postJson = {
      userType: 'user',
      taskId: this.taskDetails.TaskId,
      status: "inprogress",
      zones: { keys: [zoneDetails.templateId] },
      templates: [{
        templateId: zoneDetails.templateId,
        templateJson: zoneDetails.templateJson,
        templateName: zoneDetails.templateName,
        templateQues: zoneDetails.templateQues
      }]
    };

    const logSummary = {
      userType: postJson.userType,
      taskId: postJson.taskId,
      status: postJson.status,
      zones: postJson.zones,
      templates: [{
        templateId: zoneDetails.templateId,
        templateName: zoneDetails.templateName,
      }]
    };
    this.addTaskTemplateSubscribe = (
      await this._appServices.postData(environment.endpoint.addTaskTemplate, postJson)
    ).subscribe({
      next: async (response) => {
        const { StatusCode, Message, Data } = response;
        if (StatusCode == 200) {
          await this.loggingService.handleResponseLog(
            'info',
            { ...logSummary },
            StatusCode,
            Message,
            'addTaskTemplate Api Call to Add New Zone',
            this.componentName,
            environment.endpoint.addTaskTemplate
          );
          this._appServices.presentToast(this._translateService.instant('native_text.no_zone_added'));
          this.getZoneFromLocal();
        } else {
          this.disableaddZone = false;
          await this.loggingService.logApiError(
            'critical',
            { ...logSummary },
            { StatusCode, Message },
            `FRONTEND_ALERT: addTaskTemplate Api Call to Add New Zone`,
            this.componentName,
            environment.endpoint.addTaskTemplate
          );
          this._appServices.presentToast(Message[this._appSetting.selectedLanguage] != undefined ? Message[this._appSetting.selectedLanguage] : Message[this.encryptionService.decryptLocalStorage(this._appenum.EntityOfLocalStorageKeys.defaultOrgLanguage)]);
        }
      }, error: async (err) => {
        await this.loggingService.logApiError(
          'critical',
          { ...logSummary },
          err,
          'FRONTEND_ALERT: addTaskTemplate Api Call to Add New Zone',
          this.componentName,
          environment.endpoint.addTaskTemplate
        );
        this.disableaddZone = false;
      },
    });
  }

  async loadZoneMasterCache(): Promise<void> {
    if (!DynamicCardComponent._zoneNamesCache) {
      DynamicCardComponent._zoneNamesCache = JSON.parse(
        this.encryptionService.decrypt(
          this.encryptionService.localstorageDecrypt(
            this._appenum.EntityOfLocalStorageKeys.zoneMasterData
          )
        )
      );
    }
    this.zoneNames = DynamicCardComponent._zoneNamesCache;
  }

  trackById(index: number, item: any): any {
    return item.id || item.uniqueKey || index;
  }

  async reBindData(index) {
    try {
      this.updatedFieldsforCustomForm = undefined
      setTimeout(() => {
        if (!this._tempDynamicFormConfig.isHelpJsonLoad) {
          this.getHelpGuide();
        } else {
          this.isHelpJson = true;
        }
      }, 500)
      this.mappedData = await this._tempDynamicFormConfig.jsonValueMapped(this.serverData[index].templateId)
      setTimeout(() => {
        this.updatedFieldsforCustomForm = [this.serverData[this._tempDynamicFormConfig.lastSlideIndex]];
        console.log("this.updatedFieldsforCustomForm", this.updatedFieldsforCustomForm)
      }, 500)
      this.initializeSegments(this.mappedData);
      this.customTaskChecklist = this._tempDynamicFormConfig.taskChecklist;
      this.customJsonForm = await this.get_Zone_tree_List(this.mappedData.templateJson);
      console.log("this.customJsonForm;", this.customJsonForm)
      this._tempDynamicFormConfig.tempCustomJson = this.customJsonForm;
      this._tempDynamicFormConfig.zoneCustomJsonMap =
        this._tempDynamicFormConfig.zoneCustomJsonMap ?? new Map();
      this._tempDynamicFormConfig.zoneCustomJsonMap.set(
        this.serverData[index].templateId,
        this.customJsonForm  // fresh data
      );
      this.updateMediaCount();
      this.selectedTabIndex = this._tempDynamicFormConfig.lastSlideIndex;
      let getParent = this.isNavigateToChild == 'true' && this._tempDynamicFormConfig.lastSelection?.parent != "" ? this.mappedData.templateJson.filter(data => data.controlName == this._tempDynamicFormConfig.lastSelection?.parent) : undefined;

      // this.showZoneName = getParent && getParent.length > 0 ? getParent[0].label[this._appSetting.selectedLanguage] : this.getZoneName(this.serverData[index].templateId);
      if (getParent && getParent.length > 0) {
        this.parentData = getParent[0];          // <-- ADD THIS
        this.showZoneName = getParent[0].label[this._appSetting.selectedLanguage];
      } else {
        this.parentData = null;                   // <-- and this, for the root case
        this.showZoneName = this.getZoneName(this.serverData[index].templateId);
      }
      this.goBackLabel = this.getGoBackLabel();
      console.log("this.goBackLabel", this.goBackLabel)
      this.getRepeatableControls();
      this.isDataLoaded = true;
      this.updateTempDynamicConfig();
      setTimeout(() => {
        // this.computeValidationState();
        this.preloadAllZoneValidation()
      }, 2000)
      if (this.isNavigateToChild) {
        this.navigateTochild();
      }
    } catch (error) {
      await this.loggingService.logFunctionError(
        error,
        'reBindData',
        this.componentName,
        {
          taskid: this.taskDetails.TaskId,
          index, templateId: this.serverData?.[index]?.templateId
        }   // replace with your actual component name
      );
    }
  }

  private updateMediaCount(): void {
    try {
      if (!Array.isArray(this.customJsonForm)) {
        return;
      }

      const calculateForTitle = (titleNode: any): number => {
        let total = 0;

        if (!Array.isArray(titleNode?.children)) {
          titleNode.mediaCount = 0;
          return 0;
        }

        for (const child of titleNode.children) {

          // If child has media array
          if (Array.isArray(child?.value)) {
            total += child.value.length;
          }

          // If child is another title → calculate separately
          if (child?.controlType === 'title') {
            total += calculateForTitle(child);
          }
        }

        titleNode.mediaCount = total;
        return total;
      };
      for (const item of this.customJsonForm) {
        if (item?.controlType === 'title') {
          calculateForTitle(item);
        }
      }

    } catch (error) {
      console.error('[updateMediaCount]', error);
    }
  }

  ionViewWillLeave() {
    document.body.removeEventListener();
    this.backButtonSubscription.unsubscribe();
  }
  OpenAddZoneControl() {
    setTimeout(() => {
      this.addZoneSelection.open();
    }, 40);
  }

  submitCustomForm(e) {
    this.closefeedbackFormPopup();
  }

  feedbackForm(zoneIndex) {
    document.getElementById('feedBackFormPopup').style.display = 'block';
  }

  closefeedbackFormPopup(): void {
    this.selectedTab = 'Media';
    localStorage.setItem(
      'lastSelectSegment',
      'Media'
    );
  }


  taskLevelchecklist() {
    document.getElementById('taskchecklistModal').style.display = 'block';
  }
  submitTaskchecklist(e) {
    this.closeTaskCheclist();
  }

  closeTaskCheclist(): void {
    document.getElementById('taskchecklistModal').style.display = 'none';
  }

  BackEvent() {
    try {
      this.showAllImages = false;
      this.serverData = this._tempDynamicFormConfig.serverData;
      if (this.parentData.parent == '') {
        this.customJsonForm = this.get_Zone_tree_List(this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateJson)
        this._tempDynamicFormConfig.tempCustomJson = this.customJsonForm
        this.parentData = null;
        this.showZoneName = this.getZoneName(this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId)
        this.goBackLabel = '';
      } else {
        this.customJsonForm = this.get_Zone_tree_List(this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateJson, this.parentData.parent)
        this._tempDynamicFormConfig.tempCustomJson = this.customJsonForm
        for (var i = 0; i < this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateJson.length; i++) {
          if (this.parentData.parent == this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateJson[i]['controlName']) {
            this.parentData = this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateJson[i];
            this.showZoneName = this.parentData.label[this._appSetting.selectedLanguage]
          }
        }
        this.goBackLabel = this.getGoBackLabel(); // <-- add this
      }
      this.updateMediaCount();
      this.getRepeatableControls();
    } catch (error) {
      this.loggingService.logFunctionError(
        error,
        'BackEvent',
        this.componentName  // replace with your actual component name
      );
    }
  }

  getGoBackLabel(): string {
    console.log("this.parentData", this.parentData)
    if (!this.parentData) {
      return ''; // already at true root, nothing to go back to
    }

    if (this.parentData.parent == '') {
      // going back from current level lands on the root zone
      return this.getZoneName(this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId);
    } else {
      // going back lands on parentData.parent — find its label
      const templateJson = this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateJson;
      for (var i = 0; i < templateJson.length; i++) {
        if (this.parentData.parent == templateJson[i]['controlName']) {
          return templateJson[i].label[this._appSetting.selectedLanguage];
        }
      }
    }
    return '';
  }
  getRepeatableControls() {
    var controlList = this._tempDynamicFormConfig.tempCustomJson
    this.repeatableControlList = controlList.length > 0 ? controlList.filter(item => item.isRepeatable == true) : []
  }

  navigateTochild() {
    try {
      setTimeout(() => {
        const swiperEl = this.swiperRef?.nativeElement;
        const swiperInstance = swiperEl?.swiper;

        const slidesPerView = 3;
        const actualSlideIndex = Math.floor(this.selectedTabIndex / slidesPerView);

        if (swiperInstance && typeof swiperInstance.slideTo === 'function') {
          swiperInstance.slideTo(actualSlideIndex, 0, false);
        }
      }, 1000)
      if (this._tempDynamicFormConfig.lastSelection) {
        if (this._tempDynamicFormConfig.lastSelection.multiple && this._tempDynamicFormConfig.lastSelection.parent == '') {
          let getParent = this.mappedData.templateJson.filter(data => data.controlName == this._tempDynamicFormConfig.lastSelection.controlName);
          let selectedCatFileList = getParent[0].value;
          this.imagesList = selectedCatFileList;
          this.parentData = null;
          this.customJsonForm = this.get_Zone_tree_List(this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateJson);
          this._tempDynamicFormConfig.tempCustomJson = this.customJsonForm
        } else if (this._tempDynamicFormConfig.lastSelection.parent != '') {
          let getParent = this.mappedData.templateJson.filter(data => data.controlName == this._tempDynamicFormConfig.lastSelection.parent);
          let temp = this._tempDynamicFormConfig.get_Zone_tree_List(this.mappedData.templateJson, getParent[0].controlName)
          let getLastSelection = temp.filter(data => data.controlName == this._tempDynamicFormConfig.lastSelection.controlName);
          this._tempDynamicFormConfig.lastSelection = getLastSelection[0]
          if (this._tempDynamicFormConfig.lastSelection != null && this._tempDynamicFormConfig.lastSelection.multiple && this._tempDynamicFormConfig.lastSelection.value != undefined) {
            this.repeatableControlList = [];
            this.parentData = this._tempDynamicFormConfig.lastSelection;
            let selectedCatFileList = this._tempDynamicFormConfig.lastSelection.value;
            this.imagesList = selectedCatFileList;
            this.customJsonForm = this._tempDynamicFormConfig.get_Zone_tree_List(this.mappedData.templateJson, this._tempDynamicFormConfig.lastSelection.parent);
            this._tempDynamicFormConfig.tempCustomJson = this.customJsonForm
          } else if (this._tempDynamicFormConfig.lastSelection != null && this._tempDynamicFormConfig.lastSelection.multiple && this._tempDynamicFormConfig.lastSelection.value == undefined) {
            this.repeatableControlList = [];
            this.parentData = this.mappedData.templateJson.filter(data => data.controlName == this._tempDynamicFormConfig.lastSelection.parent)[0];
            this.customJsonForm = this._tempDynamicFormConfig.get_Zone_tree_List(this.mappedData.templateJson, this._tempDynamicFormConfig.lastSelection.parent);
            this._tempDynamicFormConfig.tempCustomJson = this.customJsonForm
          } else {
            this._tempDynamicFormConfig.lastSelection = null;
            this.imagesList = null;
          }
        }
      }
      this.updateMediaCount();
    } catch (error) {
      this.loggingService.logFunctionError(
        error,
        'navigateTochild',
        this.componentName,
        { lastSelection: this._tempDynamicFormConfig?.lastSelection }
      ).catch(() => { });
    }
  }

  get_Zone_tree_List = (items: any, controlName = "", link = 'parent') => items
    .filter(item => item[link] == controlName)
    .map(item => ({ ...item, children: this.get_Zone_tree_List(items, item.controlName) }));

  async getEvent(obj) {
    console.log("obj", obj)
    this._tempDynamicFormConfig.lastSelection = obj
    if (obj.controlType == 'title') {
      this.showZoneName = obj.label[this._appSetting.selectedLanguage];
      if (obj['children'].length > 0) {
        this.parentData = obj;
        this.customJsonForm = obj['children'];
        this._tempDynamicFormConfig.tempCustomJson = this.customJsonForm
        this.goBackLabel = this.getGoBackLabel();

        this.getRepeatableControls();
      }
    }
    else if (obj.controlType == 'photos' || obj.controlType == 'videos') {
      if (obj.value == null && obj.value == undefined) {
        let selectedCOntrolDetails = { templateId: this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId, UniqueControlId: obj.controlName }
        const canNavigate = await this.checkLocationPermissionToNavigate();
        if (canNavigate) {
          this._nav.navigateRoot(['user-panel/tasks/inspection-form-fill', { taskId: this.taskId, latitude: this.lat, longitude: this.long, fileId: 0, clickedZone: JSON.stringify(selectedCOntrolDetails) }]);
        }
      }
    }
    else if (obj.controlType == 'files') {
      if (obj.value != null && obj.value != undefined) {
        var selectedCatFileList = obj.value
        this.imagesList = selectedCatFileList;
        if (obj.multiple) {
          this.parentData = obj;
          this.customJsonForm = obj['children'];
          this._tempDynamicFormConfig.tempCustomJson = this.customJsonForm
          this.repeatableControlList = [];
        } else {
          this.parentData = obj;
          this.GotoGalleryImageDetails(this.imagesList[0], this.parentData)
        }
      } else {
        const canNavigate = await this.checkLocationPermissionToNavigate();
        if (canNavigate) {
          let fileControl = document.getElementById('fileCapture-control');
          fileControl.click();
        }
      }
    } else if (obj.controlType == 'form') {
      this.feedbackForm(this._tempDynamicFormConfig.lastSlideIndex)
    } else if (obj.controlType == 'satellite') {
      if (obj.value == null && obj.value == undefined) {
        let selectedCOntrolDetails = { templateId: this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId, UniqueControlId: obj.controlName }
        const canNavigate = await this.checkLocationPermissionToNavigate();
        if (canNavigate) {
          this._nav.navigateRoot(['user-panel/tasks/inspection-form-fill', { taskId: this.taskId, latitude: this.lat, longitude: this.long, fileId: 0, clickedZone: JSON.stringify(selectedCOntrolDetails) }]);
        }
      }
    }
    console.log("this.parentData", this.parentData)
  }

  async clickMorePhoto(obj) {
    const canNavigate = await this.checkLocationPermissionToNavigate();
    if (canNavigate) {
      if (obj.controlType == 'photos' || obj.controlType == 'videos') {
        let selectedCOntrolDetails = { templateId: this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId, UniqueControlId: obj.controlName }
        this._nav.navigateRoot(['user-panel/tasks/inspection-form-fill', { taskId: this.taskId, latitude: this.lat, longitude: this.long, fileId: 0, clickedZone: JSON.stringify(selectedCOntrolDetails) }]);
      } else if (obj.controlType == 'files') {
        let fileControl = document.getElementById('fileCapture-control');
        fileControl.click();
      }
    }
  }

  getFileDetails(e) {
    let obj = this._tempDynamicFormConfig.lastSelection;
    var fileSize;
    const element = e.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    if (fileList) {
      var totalBytes = fileList[0].size;
      if (totalBytes > 1000000) {
        fileSize = Math.floor(totalBytes / 1000000);
      } else {
        fileSize = 0;
      }
      if (obj.fileTypes.includes(fileList[0].type) && fileSize <= obj.fileSize.split('')[0]) {
        this._appServices.selectedTempFileUrl = fileList[0];
        let selectedCOntrolDetails = { templateId: this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId, UniqueControlId: obj.controlName }
        this._nav.navigateRoot(['user-panel/tasks/inspection-form-fill', { taskId: this.taskId, latitude: this.lat, longitude: this.long, fileId: 0, clickedZone: JSON.stringify(selectedCOntrolDetails) }]);
      } else {
        this._appServices.ionicCustomPromptForCors('Alert', 'File not supported please select .pdf, .doc,.docx file size should be less than ' + obj.fileSize);
      }
    }
  }

  GotoGalleryImageDetails(imgDetails, parentcontol = null) {
    this._tempDynamicFormConfig.serverUrl = imgDetails.localFileUrl //imgDetails.ServerFileUrl;
    this._tempDynamicFormConfig.FileName = imgDetails.FileName;
    this._tempDynamicFormConfig.originalFileName = imgDetails.originalFileName;
    let selectedCOntrolDetails = { templateId: this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId, UniqueControlId: parentcontol.controlName };
    const { localFileUrl, ...filteredImgDetails } = imgDetails;
    this._nav.navigateRoot(['user-panel/tasks/inspection-form-fill', {
      taskId: this.taskId,
      latitude: this.lat,
      longitude: this.long,
      fileId: 1,
      fileDetail: JSON.stringify(filteredImgDetails),
      fileName: imgDetails.serverfilename,
      clickedZone: JSON.stringify(selectedCOntrolDetails)
    }]);
  }

  async gotoPhotoSummaryPage() {
    const canNavigate = await this.checkLocationPermissionToNavigate();
    if (canNavigate) {
      this._nav.navigateRoot(['user-panel/tasks/task-summary']);
    }
  }
  async presentHelpModal() {
    const modal = await this.modalController.create({
      component: ModalConfirmaddressComponent,
      cssClass: 'help-guide-modal',
      componentProps: {
        pagename: 'dynamic-card',
        lastSelectedTierDetails: this.lastSelectedTierDetails,
        slideIndex: this.selectedTabIndex
      }
    });
    return await modal.present();
  }
  async ngOnDestroy() {
    this.zoneNames = [];
    this.orgMasterData = [];
    this.listForAddNewZone = [];
    try {
      const topModal = await this.modalController.getTop();
      if (topModal) {
        await this.modalController.dismiss({ dismissed: true });
      }
    } catch (error) {
      console.warn('Modal already dismissed or overlay not found:', error);
    }
  }
  async getHelpGuide() {
    var taskDetail = {
      TaskId: this.taskId,
      status: "inprogress"
    }

    let postJson = {
      templateId: this._tempDynamicFormConfig.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId
    };

    const logRequestHelpJson: any = {
      apiEndUrl: environment.endpoint.getOrgTemplateHelp,
      reqBody: postJson,
    };

    this.ShowSpinner = true;
    this._tempDynamicFormConfig.getHelpJsonData = [];
    this.orgTemplateApi = (await this._appServices.postData(environment.endpoint.getOrgTemplateHelp, postJson)).subscribe((res: any) => {
      this.loggingService.handleResponseLog(
        res.StatusCode == 200 ? 'info' : 'error',
        logRequestHelpJson,
        res.StatusCode,
        res.Message,
        'GetOrgTemplateHelp Api Call to Get HelpJson',
        this.componentName,
        environment.endpoint.getOrgTemplateHelp
      );
      this.ShowSpinner = false;
      if (res.StatusCode == '200') {
        this._tempDynamicFormConfig.getHelpJsonData = res.Data[0].helpJson;
        const allImageNames = res.Data[0].helpJson.map(item => item.imgName).flat();
        // this.isHelpJson = res.Data[0].helpJson.length > 0 && Object.keys(res.Data[0].helpJson[0]).length > 0 ? true : false;
        this.gethelpImages(allImageNames);
      } else {
        //this._appServices.ionicCustomAlert('', '', res.Message);
      }
    }, (err) => {
      this.loggingService.logApiError(
        'error',
        logRequest,
        err,
        'GetOrgTemplateHelp Api Call to Get HelpJson',
        this.componentName,
        environment.endpoint.getOrgTemplateHelp
      )
    });
    // }
  }


  async gethelpImages(helpimagesName) {
    const postJson = {
      directory: "HelpGuidePhotos",
      fileName: helpimagesName
    };
    const logRequestHelpGuidePhotos: any = {
      apiEndUrl: environment.endpoint.getWhiteLabelAssets,
      reqBody: postJson,
    };
    (await this._appServices.postData(environment.endpoint.getWhiteLabelAssets, postJson)).subscribe((res: any) => {
      this.loggingService.handleResponseLog(
        res.StatusCode == 200 ? 'info' : 'error',
        logRequestHelpGuidePhotos,
        res.StatusCode,
        res.Message,
        'GetWhiteLevelAssets Api Call To Get Help Guide Images',
        this.componentName,
        environment.endpoint.getWhiteLabelAssets
      );
      if (res.StatusCode == '200') {
        this.isHelpJson = helpimagesName.length > 0 ? true : false;
        this._tempDynamicFormConfig.getHelpGuideFile = res.Data;
        this._tempDynamicFormConfig.isHelpJsonLoad = true;
      }
    }, (err) => {
      this.loggingService.logApiError(
        'error',
        logRequest,
        err,
        'GetWhiteLevelAssets Api Call To Get Help Guide Images',
        this.componentName,
        environment.endpoint.getWhiteLabelAssets
      )
    });

  }
  toggleShowAllImages(event: MouseEvent): void {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    this.showAllImages = !this.showAllImages;
  }

  openModal() {
    setTimeout(() => {
      this.additionalFeatureRef.open();
    }, 40);
  }

  getRepeatableControlDetails(e: any) {
    try {
      const selectedControl = this.mappedData.templateJson.find(itm => itm.controlName == e.controlName);
      if (!selectedControl) throw new Error('Control not found.');
      this.count = selectedControl.AddCount += 1;
      this.label = selectedControl.Originallabel;
      this.selectedControlToMaintan = selectedControl;
      this.featurename = `${e.Originallabel[this._appSetting.selectedLanguage]} ${this.count}`;
      document.getElementById('newControlName').style.display = 'block';
      this.selectedTreeControlList = [];
      this.nested_to_flat([e]);
    } catch (error) {
      console.log("getRepeatableControlDetails", error)
    }
  }

  nested_to_flat(arr) {
    try {
      arr.forEach(i => {
        if (i.hasOwnProperty('children')) {
          if (i.children.length > 0) {
            this.nested_to_flat(i.children);
          }
          // delete i.children;
          this.selectedTreeControlList.push(i);
        }
      });
    } catch (error) {
      console.log("nested_to_flat error", error)
    }
  }

  async AddNewControls() {
    try {
      this.parentData = null;
      document.getElementById('newControlName').style.display = 'none';
      const prefix = "_" + Date.now();
      const temp = this.selectedTreeControlList;

      const templateDetails = await this.idbservice.getTemplateDetailFromIdb(
        this.taskId,
        this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId
      );

      if (!templateDetails.length) {
        console.error("No template details found for task:", this.taskId);
        return;
      }

      let needsFullRefresh = false; // track instead of calling ngOnInit inline

      for (const [i, item] of temp.entries()) {
        item.controlName += prefix;
        item.name += prefix;

        if (item.isRepeatable) {
          item.label = { [this._appSetting.selectedLanguage]: this.featurename };
          const nameLabel = this.multilang.filter(
            itm => itm.code !== this._appSetting.selectedLanguage
          );
          nameLabel.forEach(itm => {
            item.label[itm.code] = this.label[itm.code] + ' ' + this.count;
            item.customControlLabel[itm.code] = this.featurename;
          });
        } else {
          item.parent = item.parent ? item.parent + prefix : "";
        }

        if ('value' in item) {
          delete item.value;
          item.ui.class = '';
        }

        if (this.AddLastOrNext === "addLast") {
          item.isRepeatable = false;
          templateDetails[0].templateJson.push(item);
          this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateJson.push(item);
        }

        this.customJsonForm = this.get_Zone_tree_List(
          this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateJson
        );

        this._tempDynamicFormConfig.tempCustomJson = this.customJsonForm;
        const temp1 = this._tempDynamicFormConfig.tempCustomJson.find(itm => itm.controlName === item.parent);

        if (!temp1) {
          this.parentData = null;
          this.isNavigateToChild = false;
          needsFullRefresh = true; // just mark it, don't call ngOnInit yet
        } else {
          this._tempDynamicFormConfig.lastSelection = temp1;
          this.parentData = temp1;
          this.customJsonForm = temp1.children;
          this._tempDynamicFormConfig.tempCustomJson = this.customJsonForm;
          this.getRepeatableControls();
        }
      }

      if (this.AddLastOrNext === "addLast") {
        await this.idbservice.updateTemplateAfterControlAdd(
          this.taskId,
          this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId,
          templateDetails[0].templateJson
        );
      }

      // Run the refresh ONCE, after the loop, and wait for it
      if (needsFullRefresh) {
        await this.ngOnInit();
      }

      this.featurename = '';
      await this.addTemplatetoserver();
    } catch (error) {
      await this.loggingService.logFunctionError(
        error,
        'AddNewControls',
        this.componentName,
        {
          taskId: this.taskId,
          templateId: this.serverData?.[this._tempDynamicFormConfig?.lastSlideIndex]?.templateId,
          lastSlideIndex: this._tempDynamicFormConfig?.lastSlideIndex,
          addLastOrNext: this.AddLastOrNext,
          controlCount: this.selectedTreeControlList?.length
        }
      );
      console.error("add new control error", error);
    }
  }


  async addTemplatetoserver() {
    try {
      this._tempDynamicFormConfig.isRunningSaveData.next(true);
      let flatTemplateJson = JSON.parse(JSON.stringify(this._tempDynamicFormConfig.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateJson));
      flatTemplateJson.forEach(item => {
        if ('value' in item) {
          delete item.value;
        }
      });
      const postJson = {
        userType: 'user',
        zones: { keys: [this._tempDynamicFormConfig.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId] },
        taskId: this.taskId,
        currentTime: new Date().toISOString(),
        templates: [{
          templateId: this._tempDynamicFormConfig.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId,
          templateJson: flatTemplateJson
        }],
        status: "inprogress",
      };

      const logSummary = {
        userType: postJson.userType,
        taskId: postJson.taskId,
        status: postJson.status,
        zones: postJson.zones,
      };

      this.addTaskTemplateAddTempSubscribe = (
        await this._appServices.postData(environment.endpoint.addTaskTemplate, postJson)
      ).subscribe({
        next: async (response) => {
          const { StatusCode, Message, Data } = response;
          if (StatusCode == "200") {
            await this.loggingService.handleResponseLog(
              'info',
              { ...logSummary },
              StatusCode,
              Message,
              'addTaskTemplate Api Call to Add New Control',
              this.componentName,
              environment.endpoint.addTaskTemplate
            );
            this._tempDynamicFormConfig.isRunningSaveData.next(false);
          } else {
            await this.loggingService.logApiError(
              'critical',
              { ...logSummary },
              { StatusCode, Message },
              `FRONTEND_ALERT: addTaskTemplate Api Call to Add New Control`,
              this.componentName,
              environment.endpoint.addTaskTemplate
            );
          }
        },
        error: async (err) => {
          await this.loggingService.logApiError(
            'critical',
            { ...logSummary },
            err,
            'FRONTEND_ALERT: addTaskTemplate Api Call to Add New Control',
            this.componentName,
            environment.endpoint.addTaskTemplate
          );
        },
      });
    } catch (error) {

    }
  }

  closemodal() {
    try {
      const newControlNameModal = document.getElementById('newControlName');
      if (newControlNameModal) {
        newControlNameModal.style.display = 'none';
      } else {
        console.error('Modal element with ID "newControlName" not found.');
      }

      this.featurename = '';
      this.additionalSelectedControl = '';
      this.selectedControlToMaintan = this.selectedControlToMaintan.AddCount -= 1;
    } catch (error) {

    }
  }

  onTabClick(index: number): void {
    // this.selectedTab = 'Media';
    // this.selectedTab = null;
    localStorage.removeItem('lastSelectSegment')
    this.selectedTabIndex = index;
    this.isHelpJson = false;
    this._tempDynamicFormConfig.lastSlideIndex = index;
    this.isNavigateToChild = false;
    this._tempDynamicFormConfig.zoneChecklistvalue = [];
    if (this._tempDynamicFormConfig.serverData.length !== this._tempDynamicFormConfig.lastSlideIndex) {
      this.isZone = true;
      this.repeatableControlList = [];
      this.parentData = null;
      this.reBindData(this._tempDynamicFormConfig.lastSlideIndex)
    } else {
      console.log("else part")
      // this.getZoneWiseData();
      this.isZone = false;
    }
  }
  onSlideReachEnd() {
    this.showNextButton = false;
    this.showPrevButton = true;
  }

  // Hide 'Left' icon on manual scroll to start
  onSlideReachStart() {
    this.showPrevButton = false;
    this.showNextButton = true;
  }

  checkLocationPermissionToNavigate(): Promise<boolean> {
    return new Promise((resolve) => {
      this.permissionDenied$.pipe(take(1)).subscribe(permissionDenied => {
        if (permissionDenied) {
          if (this.permissionMessage) {
            this.permissionMessage.shakeMessage();
          }
          resolve(false);
        } else {
          resolve(true);
        }
      });
    });
  }
  // renamed your existing logic into this private method
  private checkMediaError(tempCustomJson: any[]): boolean {
    if (!tempCustomJson?.length) return false;

    for (const control of tempCustomJson) {
      if (control.controlType === 'photos' && control.isVisible && control.mandatory == 1) {
        if (!control.value || control.value.length === 0) return true;
      }
      if (control.controlType === 'title' && control.isVisible && control.children?.length) {
        if (this.hasMediaErrorInChildren(control.children)) return true;
      }
    }
    return false;
  }

  isMediaError(formData: any): boolean {
    return formData.controlType != 'title' &&
      this._tempDynamicFormConfig?.highlightcontrols &&
      formData?.mandatory == 1 &&
      (!formData?.value || formData.value.length == 0);
  }

  isMediaRecomended(formData: any): boolean {
    return formData.controlType != 'title' &&
      this._tempDynamicFormConfig?.highlightcontrols &&
      formData?.mandatory == 2 &&
      (!formData?.value || formData.value.length == 0);
  }

  isMediaErrorontitle(formData: any): boolean {
    return (
      formData?.controlType == 'title' &&
      this._tempDynamicFormConfig?.highlightcontrols &&
      formData?.mandatory == 1 &&
      Array.isArray(formData?.children) &&
      formData.children.some(
        child =>
          child?.mandatory == 1 &&
          (!child?.value || child.value.length == 0)
      )
    );

  }

  isMediaRecomendedontitle(formData: any): boolean {
    return (formData.controlType == 'title' &&
      this._tempDynamicFormConfig?.highlightcontrols &&
      formData?.mandatory == 2 &&
      Array.isArray(formData?.children) &&
      formData.children.some(
        child =>
          child?.mandatory == 2 &&
          (!child?.value || child.value.length == 0)
      )
    )
  }

  getTitleValidationState(control: any): 'mandatory' | 'recommended' | null {
    if (!this._tempDynamicFormConfig?.highlightcontrols) {
      return null;
    }
    if (control.controlType !== 'title' || !control.children?.length) {
      return null;
    }
    return this.checkValidation(control);
  }
  private checkValidation(control: any): 'mandatory' | 'recommended' | null {
    let hasRecommended = false;
    for (const child of control.children) {

      // 🔹 Leaf node
      if (!child.children || child.children.length === 0) {

        const hasValue = child?.value && child.value.length > 0;
        if (child.mandatory == 1 && !hasValue) {
          return 'mandatory'; // highest priority → stop immediately
        }
        if (child.mandatory == 2 && !hasValue) {
          hasRecommended = true;
        }

      } else {
        // Recursive case
        const childState = this.checkValidation(child);

        if (childState === 'mandatory') {
          return 'mandatory';
        }

        if (childState === 'recommended') {
          hasRecommended = true;
        }
      }
    }
    if (hasRecommended) return 'recommended';
    return null;
  }

  getTitleIndicator(control: any): 'mandatory' | 'recommended' | null {

    if (control.controlType !== 'title' || !control.children?.length) {
      return null;
    }

    return this.checkValidation(control);
  }

  initializeSegments(template: any): void {
    try {
      this.segments = [];
      this.selectedTab = null;

      if (!template) return;
      // Check Question exists
      const hasQuestion =
        Array.isArray(template?.templateQues) &&
        template.templateQues.length > 0;

      // Check Media exists (your rule)
      const hasMedia =
        Array.isArray(template?.templateJson) &&
        template.templateJson.length > 0;

      // Add available segments
      if (hasMedia) {
        this.segments.push({
          value: 'Media',
          labelKey: 'self_pwa_text.media_text'
        });
      }

      if (hasQuestion) {
        this.segments.push({
          value: 'Questionnaire',
          labelKey: 'self_pwa_text.questionnaire_text'
        });
      }

      //  Apply ordering ONLY if both exist
      if (hasMedia && hasQuestion) {

        const segmentConfig = template.templateJson.find(
          (item: any) => item.controlType === 'segment'
        );

        let order: string[];

        if (
          segmentConfig &&
          Array.isArray(segmentConfig.segmentOrder) &&
          segmentConfig.segmentOrder.length
        ) {
          // New template → use configured order
          order = segmentConfig.segmentOrder;
        } else {
          //Old template → default Media first
          order = ['Media', 'Questionnaire'];
        }

        this.segments.sort((a, b) => {
          const indexA = order.indexOf(a.value);
          const indexB = order.indexOf(b.value);

          return (
            (indexA === -1 ? 999 : indexA) -
            (indexB === -1 ? 999 : indexB)
          );
        });
      }

      // Restore saved tab if exists
      const savedTab = localStorage.getItem('lastSelectSegment');

      if (
        savedTab &&
        this.segments.find(s => s.value === savedTab)
      ) {
        this.selectedTab = savedTab;
      } else {
        this.selectedTab =
          this.segments.length > 0
            ? this.segments[0].value
            : null;
      }

    } catch (error) {
      console.error('initializeSegments error:', error);
    }
  }

  onSegmentChange(event: any): void {
    this.serverData = this._tempDynamicFormConfig.serverData;
    this.customJsonForm = this.get_Zone_tree_List(this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateJson)
    this._tempDynamicFormConfig.tempCustomJson = this.customJsonForm
    this.parentData = null;
    this.showZoneName = this.getZoneName(this.serverData[this._tempDynamicFormConfig.lastSlideIndex].templateId)
    const selected = event.detail.value;
    localStorage.setItem(
      'lastSelectSegment',
      selected
    );
    console.log("updatedFieldsforCustomForm", this.updatedFieldsforCustomForm)
    this.updateMediaCount();
    this.getRepeatableControls();
  }

  async saveandsubmitlater() {
    this.checkuploadingimage = this.encryptionService.decrypt(this.encryptionService.sessionstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.isRunningAsyncUtility));
    if (await this.isFileUploadInProgress()) {
      return;
    }
    const alert = await this._appServices._alertController.create({
      cssClass: 'Confirmation_popup',
      header: this.saveLaterTitle,
      message: this.submitlaterText,
      buttons: [
        {
          text: this.cancelText,
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: this.saveNewBtn,
          handler: async () => {
            this.afterConfirmSubmit();
            // this._nav.navigateRoot(['user-panel/tasks/success', { isDataSave: true, tasksubmit: 'false' }]);
          }
        }
      ]
    });
    await alert.present();
  }

  async afterConfirmSubmit() {
    try {
      // await this._appServices.showLoader(); // optional

      await this.saveSubmit(); // wait for API
      await this._appServices.hideLoader();
      this._nav.navigateRoot([
        'user-panel/tasks/success',
        { isDataSave: true, tasksubmit: 'false' }
      ]);

    } catch (err) {
      await this._appServices.hideLoader();
      console.error(err);
    }
  }

  clearMediaValues(controls: any[]) {
    if (!Array.isArray(controls)) return;

    controls.forEach(control => {

      // Case 1: Media controls
      if (['photos', 'videos', 'files'].includes(control.controlType)) {
        if (Array.isArray(control.value)) {
          // control.value = []; 
          delete control['value']
        }
        if (control?.selectedTierModels && Array.isArray(control.selectedTierModels)) {
          delete control['selectedTierModels']
        }
      }

      // Case 2: Title → has children
      if (control.controlType === 'title' && Array.isArray(control.children)) {
        this.clearMediaValues(control.children); // 🔁 recursion
      }

      // Optional: if other types also have children (safety)
      if (Array.isArray(control.children)) {
        this.clearMediaValues(control.children);
      }

    });
  }
  //Save and  Submit
  async saveSubmit(status = "inprogress") {
    // this._appServices.showLoader();
    this.ZonechecklistValue = []
    this.taskCheckListValueToSubmit = []
    var obj = {};
    for (var i = 0; i < this._tempDynamicFormConfig.serverData.length; i++) {
      this.flatTemplateJson = this._tempDynamicFormConfig.serverData[i].templateJson
      await this.clearMediaValues(this.flatTemplateJson);
      this.flatTemplateJson = this._appServices.validateAndRepairTemplateJson(
        this.flatTemplateJson,
        this._tempDynamicFormConfig.tempTemplateData,
        i,
        this._tempDynamicFormConfig.serverData[i].templateId,
        { componentName: this.componentName, taskId: this.taskId, logLevel: this._appenum.EntityOfLogLevel.Error }
      )
      console.log("this.flatTemplateJson", this.flatTemplateJson);
      this.ZoneLevelQuesValue = JSON.parse(JSON.stringify(this._tempDynamicFormConfig.serverData[i].templateQues))
      const zoneChecklist = this.ZoneLevelQuesValue.filter(itm => itm.controlvalue != '' && itm.controlType != 'table')
      zoneChecklist.forEach(item => {
        obj = {
          "TaskID": this.taskId,
          "controlName": item.controlName,
          "controlType": item.controlType,
          "controlvalue": item.controlvalue,
          "templateName": this._tempDynamicFormConfig.serverData[i].templateName,
          "templateId": this._tempDynamicFormConfig.serverData[i].templateId,
        }
        this.ZonechecklistValue.push(obj)
      })
      const zoneTableChecklist = this.ZoneLevelQuesValue.filter(itm => itm.controlType == 'table')
      zoneTableChecklist.forEach(item => {
        obj = {
          "TaskID": this.taskId,
          "controlName": item.controlName,
          "controlType": item.controlType,
          "controlvalue": item.tableData.value,
          "templateName": this._tempDynamicFormConfig.serverData[i].templateName,
          "templateId": this._tempDynamicFormConfig.serverData[i].templateId,
        }
        this.ZonechecklistValue.push(obj)
      });
      var templateData = {
        templateId: this._tempDynamicFormConfig.serverData[i].templateId,
        templateQues: this._tempDynamicFormConfig.serverData[i].templateQues,
        templateQuesValue: this.ZonechecklistValue.length > 0 ? this.ZonechecklistValue : null,
        templateJson: this.flatTemplateJson
      }
      this.zoneKeys.push(this._tempDynamicFormConfig.serverData[i].templateId)
      this.templatesData.push(templateData)
    }
    if (this._tempDynamicFormConfig.taskChecklist && this._tempDynamicFormConfig.taskChecklist.length > 0) {
      const taskLevelChecklist = this._tempDynamicFormConfig.taskChecklist.filter(itm => itm.controlvalue != '')
      taskLevelChecklist.forEach(item => {
        const obj = {
          "TaskID": this.taskId,
          "controlName": item.controlName,
          "controlType": item.controlType,
          "controlvalue": item.controlvalue,
        }
        this.taskCheckListValueToSubmit.push(obj)
      })
    }
    this.templatesData.forEach(item => {
      item.templateQuesValue = this.ZonechecklistValue.length > 0 ? this.ZonechecklistValue.filter(itm => itm.templateId == item.templateId) : null
    })
    const postJson = {
      userType: 'user',
      zones: { keys: this.zoneKeys },
      taskId: this.taskId,
      status: "inprogress",
      taskChecklist: { checklist_value: this.taskCheckListValueToSubmit.length > 0 ? this.taskCheckListValueToSubmit : null },
      templates: this.templatesData
    }
    var taskDetail = {
      TaskId: this.taskId,
      status: status
    };
    const agentId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId));
    await this._appServices.prepareTaskTemplateDataforUpdate(
      postJson.templates,
      agentId,
      this.taskId
    );
    this.ShowSpinner = true;
    this._appServices.showLoader();
    await this._appServices.postDataWithPromise(environment.endpoint.addTaskTemplate, postJson).then((res: any) => {

      this.ShowSpinner = false;
      this._appServices.hideLoader();
      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: environment.endpoint.addTaskTemplate,
          response: {
            responseCode: res.StatusCode,
            responseMsg: res.Message,
            result: res
          },
          // executionTime: ""
        },
        taskDetails: taskDetail
      }
      this._appServices.logsActivity(
        res.StatusCode == 200
          ? this._appenum.EntityOfLogLevel.Info
          : this._appenum.EntityOfLogLevel.Critical,
        `${res.StatusCode != 200 ? 'FRONTEND_ALERT ' : ' '} addTaskTemplate APi Call to Save & Submit Later Inspection`,
        this.componentName,
        paramRequest.httpRequest,
        paramRequest.taskDetails,
        environment.endpoint.addTaskTemplate   // apiName
      );
      if (res.StatusCode == 200) {
        // this.getZoneWiseData();
      } else {
        this._appServices.presentToast(res.Message[this.appSetting.selectedLanguage] != undefined ? res.Message[this._appServices.selectedLanguage] : res.Message[this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.defaultLanguageSelected))]);
        this._nav.navigateRoot(['verify-otp']);
        window.location.reload();
      }
    }, (err) => {
      this._appServices.hideLoader()
      this.ShowSpinner = false;
      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: environment.endpoint.addTaskTemplate,
          // payLoad : postJson,
          response: {
            responseCode: err.status,
            responseMsg: err.message,
            result: err
          },
          // executionTime: ""
        },
        taskDetails: taskDetail
      }
      this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Critical, 'FRONTEND_ALERT addTaskTemplate APi Call to Save & Submit Later Inspection', this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, environment.endpoint.addTaskTemplate);
    });
  }

  async isFileUploadInProgress() {
    var InspectionFileData: any = await this.idbservice.getTaskFileDetailsToUpload(this.taskId, this._appServices.UploadMaxRetryHit, this.orgId);
    if (InspectionFileData.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  onQuesFormChanged() {
    this.computeValidationState();
  }

  private triggerSuccessIconQues() {
    this.showSuccessIconQues = true;
    if (this.successIconQuesTimer) clearTimeout(this.successIconQuesTimer);
    this.successIconQuesTimer = setTimeout(() => {
      this.showSuccessIconQues = false;
    }, 4500);
  }

  isMandatoryQuesPending(updatedFieldsforCustomForm: any[]): boolean {
    // don't run until questionnaire data is actually loaded
    if (!updatedFieldsforCustomForm?.length ||
      !updatedFieldsforCustomForm[0]?.templateQues?.length) {
      return false;
    }
    return this.checkQuesError(updatedFieldsforCustomForm);
  }

  private checkQuesError(updatedFieldsforCustomForm: any[]): boolean {
    if (!updatedFieldsforCustomForm?.length) return false;

    for (const template of updatedFieldsforCustomForm) {
      if (!template.templateQues?.length) continue;

      for (const ques of template.templateQues) {
        // skip header/label controls
        if (ques.controlType === 'label' || ques.controlType === 'title') continue;

        // skip if not required
        if (!ques.isRequired) continue;

        // visibleOn check — 3 cases:
        // 1. visibleOn does not exist → include (no restriction)
        // 2. visibleOn is array → must include 'self'
        // 3. visibleOn is string → must equal 'self'
        if (ques.visibleOn !== undefined && ques.visibleOn !== null) {
          const isSelfVisible = Array.isArray(ques.visibleOn)
            ? ques.visibleOn.includes('self')
            : ques.visibleOn === 'self';
          if (!isSelfVisible) continue; // skip if not visible to self
        }

        const isEmpty = ques.controlvalue === null ||
          ques.controlvalue === undefined ||
          ques.controlvalue === '' ||
          (Array.isArray(ques.controlvalue) && ques.controlvalue.length === 0);

        if (isEmpty) return true;
      }
    }
    return false;
  }

  isMandatoryMediaPending(tempCustomJson: any[]): boolean {
    const hasPending = this.checkMediaError(tempCustomJson);

    // was pending before, now fulfilled → trigger success icon
    if (this.wasMediaPending && !hasPending) {
      this.showSuccessIcon = true;
      if (this.successIconTimer) clearTimeout(this.successIconTimer);
      this.successIconTimer = setTimeout(() => {
        this.showSuccessIcon = false;
      }, 4500);
    }

    this.wasMediaPending = hasPending;
    return hasPending;
  }

  isZonePending(tempCustomJson: any[], updatedFieldsforCustomForm: any[]): boolean {
    const hasMediaPending = this.checkMediaError(tempCustomJson);
    const hasQuesPending = this.checkQuesError(updatedFieldsforCustomForm);
    const hasPending = hasMediaPending || hasQuesPending;

    if (this.wasZonePending && !hasPending) {
      this.showZoneSuccessIcon = true;
      if (this.zoneSuccessIconTimer) clearTimeout(this.zoneSuccessIconTimer);
      this.zoneSuccessIconTimer = setTimeout(() => {
        this.showZoneSuccessIcon = false;
      }, 4500);
    }

    if (hasPending) {
      // immediately hide success if something becomes pending again
      this.showZoneSuccessIcon = false;
      if (this.zoneSuccessIconTimer) clearTimeout(this.zoneSuccessIconTimer);
    }

    this.wasZonePending = hasPending;
    return hasPending;
  }

  private hasMediaErrorInChildren(children: any[]): boolean {
    if (!children?.length) return false;
    for (const child of children) {
      if (child.controlType === 'photos' && child.isVisible && child.mandatory == 1) {
        if (!child.value || child.value.length === 0) return true;
      }
      if (child.controlType === 'title' && child.isVisible && child.children?.length) {
        if (this.hasMediaErrorInChildren(child.children)) return true;
      }
    }
    return false;
  }

  // computeValidationState() {
  //   this.mediaHasError = this.checkMediaError(this._tempDynamicFormConfig.tempCustomJson);
  //   this.quesHasError = this.checkQuesError(this.updatedFieldsforCustomForm);
  //   console.log("quesHasError", this.quesHasError)
  //   // media success icon
  //   if (this.wasMediaPending && !this.mediaHasError) {
  //     this.showSuccessIcon = true;
  //     if (this.successIconTimer) clearTimeout(this.successIconTimer);
  //     this.successIconTimer = setTimeout(() => this.showSuccessIcon = false, 4500);
  //   }
  //   if (this.mediaHasError) {
  //     this.showSuccessIcon = false;
  //     if (this.successIconTimer) clearTimeout(this.successIconTimer);
  //   }
  //   this.wasMediaPending = this.mediaHasError;

  //   // ques success icon
  //   if (this.wasQuesPending && !this.quesHasError) {
  //     this.showSuccessIconQues = true;
  //     if (this.successIconQuesTimer) clearTimeout(this.successIconQuesTimer);
  //     this.successIconQuesTimer = setTimeout(() => this.showSuccessIconQues = false, 4500);
  //   }
  //   if (this.quesHasError) {
  //     this.showSuccessIconQues = false;
  //     if (this.successIconQuesTimer) clearTimeout(this.successIconQuesTimer);
  //   }
  //   this.wasQuesPending = this.quesHasError;

  //   // zone combined
  //   this.wasZonePending = this.mediaHasError || this.quesHasError;
  // }
  computeValidationState() {
    this.mediaHasError = this.checkMediaError(this._tempDynamicFormConfig.tempCustomJson);
    this.quesHasError = this.checkQuesError(this.updatedFieldsforCustomForm);

    // media success icon
    if (this.wasMediaPending && !this.mediaHasError) {
      this.showSuccessIcon = true;
      if (this.successIconTimer) clearTimeout(this.successIconTimer);
      this.successIconTimer = setTimeout(() => this.showSuccessIcon = false, 4500);
    }
    if (this.mediaHasError) {
      this.showSuccessIcon = false;
      if (this.successIconTimer) clearTimeout(this.successIconTimer);
    }
    this.wasMediaPending = this.mediaHasError;

    // ques success icon
    if (this.wasQuesPending && !this.quesHasError) {
      this.showSuccessIconQues = true;
      if (this.successIconQuesTimer) clearTimeout(this.successIconQuesTimer);
      this.successIconQuesTimer = setTimeout(() => this.showSuccessIconQues = false, 4500);
    }
    if (this.quesHasError) {
      this.showSuccessIconQues = false;
      if (this.successIconQuesTimer) clearTimeout(this.successIconQuesTimer);
    }
    this.wasQuesPending = this.quesHasError;

    // zone combined (selected zone)
    this.wasZonePending = this.mediaHasError || this.quesHasError;

    // ── per-zone validation map for ALL zones ──────────────
    this._tempDynamicFormConfig.serverData?.forEach((zone: any) => {

      const isCurrentZone = zone.templateId === this.serverData[this.selectedTabIndex]?.templateId;
      const tempJson = this._tempDynamicFormConfig.zoneCustomJsonMap?.has(zone.templateId)
        ? this._tempDynamicFormConfig.zoneCustomJsonMap.get(zone.templateId)
        : isCurrentZone
          ? this._tempDynamicFormConfig.tempCustomJson
          : null;

      const hasMedia = tempJson ? this.checkMediaError(tempJson) : false;

      // ques — always use serverData directly, no preload needed
      const hasQues = this.checkQuesErrorByTemplateId(zone.templateId);
      this.zoneValidationMap.set(zone.templateId, hasMedia || hasQues);
    });
  }
  async preloadAllZoneValidation() {
    if (!this._tempDynamicFormConfig.highlightcontrols) return; // only if validation mode is on
    this._tempDynamicFormConfig.zoneCustomJsonMap =
      this._tempDynamicFormConfig.zoneCustomJsonMap || new Map();
    for (const zone of this.serverData) {
      // skip current zone — already loaded by reBindData
      // if (this._tempDynamicFormConfig.zoneCustomJsonMap.has(zone.templateId)) continue;

      try {
        const mappedData = await this._tempDynamicFormConfig.jsonValueMapped(zone.templateId);
        const customJsonForm = await this.get_Zone_tree_List(mappedData.templateJson);
        this._tempDynamicFormConfig.zoneCustomJsonMap.set(zone.templateId, customJsonForm);
      } catch (err) {
        console.warn('preloadAllZoneValidation failed for:', zone.templateId, err);
      }
    }
    // recompute now all zones are loaded
    this.computeValidationState();
  }

  private checkQuesErrorByTemplateId(templateId: string): boolean {
    const serverTemplate = this.serverData?.find(
      (s: any) => s.templateId === templateId
    );
    if (!serverTemplate) return false;
    return this.checkQuesError([serverTemplate]);
  }
  // async onTemplateQuesUpdated(updatedFormJson: any[]) {
  //   console.log("this.serverData", this._tempDynamicFormConfig.serverData);
  //   this._tempDynamicFormConfig.serverData = this._tempDynamicFormConfig.serverData.map((zone: any) => {
  //     const updatedZone = updatedFormJson.find((z: any) => z.templateId === zone.templateId);
  //     if (updatedZone) {
  //       return { ...zone, templateQues: updatedZone.templateQues };
  //     }
  //     return zone;
  //   });
  //   this.updatedFieldsforCustomForm = updatedFormJson;
  //   console.log("this.serverData", this._tempDynamicFormConfig.serverData);
  //   console.log("this.updatedFieldsforCustomForm", this.updatedFieldsforCustomForm)
  // }

  async onTemplateQuesUpdated(updatedFormJson: any[]) {
    // console.log("updatedFormJson", updatedFormJson)
    this._tempDynamicFormConfig.serverData.forEach((zone: any) => {
      const updatedZone = updatedFormJson.find((z: any) => z.templateId === zone.templateId);
      if (updatedZone) {
        zone.templateQues = updatedZone.templateQues; // 
      }
    });
    // console.log("this._tempDynamicFormConfig.serverData", this._tempDynamicFormConfig.serverData)
    console.log("updatedFormJson", updatedFormJson)
    console.log("this._tempDynamicFormConfig.serverData-----------------", this._tempDynamicFormConfig.serverData)
    this.updatedFieldsforCustomForm = updatedFormJson;
  }
}
